import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Loader2, BookOpen, GraduationCap, UserPlus, Users } from 'lucide-react';
import { useMySchoolMembership, useSchoolPrograms, useSchoolCohorts, useSchoolEnrollmentRequests } from '@/hooks/useSchoolApi';

export default function SchoolDashboard() {
  const { data: membership } = useMySchoolMembership();
  const schoolId = (membership as any)?.schools?.id || membership?.school_id;
  const { data: programs, isLoading: progsLoading } = useSchoolPrograms(schoolId);
  const { data: cohorts, isLoading: cohortsLoading } = useSchoolCohorts(schoolId);
  const { data: requests, isLoading: reqsLoading } = useSchoolEnrollmentRequests(schoolId);

  const isLoading = progsLoading || cohortsLoading || reqsLoading;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  const stats = [
    { label: 'Programs', value: programs?.length || 0, icon: BookOpen },
    { label: 'Cohorts', value: cohorts?.length || 0, icon: GraduationCap },
    { label: 'Pending Requests', value: requests?.length || 0, icon: UserPlus },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Dashboard</h2>
        <p className="text-muted-foreground text-sm">
          Overview of your school — Role: <Badge variant="outline" className="ml-1">{membership?.role}</Badge>
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-3">
        {stats.map((stat) => (
          <Card key={stat.label}>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">{stat.label}</CardTitle>
              <stat.icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
